import React, { memo } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import { TRANSIT_TIME_OPTIONS } from 'apps/spot-quote-control-panel/constants/spotBiddingConfig'
import {
  ISpotBiddingRule,
  ICarrierWaitTimeCriteria,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

interface ICarrierWaitTimeProps {
  value: RecursivePartial<ICarrierWaitTimeCriteria>
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
}

export const CarrierWaitTime = memo<ICarrierWaitTimeProps>(({ onChange, value }) => {
  const { rangeEnd = '', rangeStart = '' } = value || {}

  const transitTimeValue = `${rangeStart ? Number(rangeStart) : ''}-${
    rangeEnd ? Number(rangeEnd) : ''
  }`

  const transitTimeHandler = (e: ISelectOption<string>) => {
    const { value: transitTime = '' } = e || {}
    const [transitStart, transitEnd] = transitTime.split('-') || []

    onChange({
      carrierWaitTimeCriteria: {
        rangeStart: transitStart,
        rangeEnd: transitEnd,
      },
    })
  }

  return (
    <>
      <div className='col-md-6 col-xs-4'>
        <Select
          label='Excess Transit Hours'
          placeholder='Choose an option'
          options={TRANSIT_TIME_OPTIONS}
          value={transitTimeValue}
          onChange={transitTimeHandler}
          dataTest='modal-carrier-wait-time-option'
          required
          large
        />
      </div>
    </>
  )
})
